import { PATH } from '..';
import { checkRegion } from '@utils/api';
import { useEffect, useState } from 'react';
import { Navigate, Outlet, useNavigate } from 'react-router-dom';

export const ForbiddenCountryRoute = () => {
  const nav = useNavigate();
  const [error, setError] = useState(null);
  const [dataRegion, setDataRegion] = useState(null);
  const [forbiddenCountry, setForbiddenCountry] = useState(false);

  useEffect(() => {
    const fetchRegionData = async () => {
      try {
        const data = await checkRegion();
        if (data) setDataRegion(data);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      } catch (error: any) {
        if (error.response && error.response.status === 403) {
          setForbiddenCountry(true);
        } else setError(error);
      }
    };

    fetchRegionData();
  }, []);

  useEffect(() => {
    if (error) {
      console.log(error);
      nav(PATH.ERROR);
    }
  }, [error, nav]);

  if (forbiddenCountry) {
    return <Navigate to={PATH.FORBIDDEN_COUNTRY} replace />;
  }

  if (dataRegion) return <Outlet />;
};
